import React from "react";
import { extractCSSProperties } from "./utils/extractCss";
import { BTN, IMG, TEXT, VIDEO, Col, Row, Container, Grid } from "./Components";
import { IFRAME } from "./Components/Iframe";

export const useRenderNode = () => {
  const renderMapper: any = {
    GridItem: Grid,
    Container: Container,
    Row: Row,
    Col: Col,
    Text: TEXT,
    Image: IMG,
    Video: VIDEO,
    Button: BTN,
    IFrame: IFRAME,
  };

  const renderNode = (node: any, nodesMap: any) => {
    if (!node) return null;
    const Component: any = renderMapper[node.type.resolvedName as any] as any;
    if (!Component) {
      console.error(`No component defined for type "${node.type}"`);
      return null;
    }
    const children = node?.nodes?.map((childId: any) => renderNode(nodesMap[childId], nodesMap));

    const componentStyles: any = extractCSSProperties(node.props);
    const restProps = JSON.parse(JSON.stringify(node.props));

    Object.keys(node.props).forEach(key => {
      if ((componentStyles[key] || ["shadow", "fillSpace"].includes(key)) && key !== "src") {
        delete restProps[key];
      }
    });

    restProps.style = componentStyles;

    return <Component {...restProps}>{children}</Component>;
  };

  return renderNode;
};
